import {
  FlowBlockValueTemplateDurationSchema,
  FlowDurationUnits,
  FlowMirthMessageType,
} from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const maximumTimeoutDuration = {
  value: 20,
  units: FlowDurationUnits.Minutes,
};

export const MirthBlockConfigSchema = z.object({
  messageType: z.enum(FlowMirthMessageType),
  message: z.string(),
  path: z.string().optional().default('/'),
  timeout: FlowBlockValueTemplateDurationSchema({
    pathName: 'timeout',
    maxDuration: maximumTimeoutDuration,
  })
    .optional()
    .default({
      value: '45',
      units: FlowDurationUnits.Seconds,
    }),
});

export type MirthBlockConfig = z.infer<typeof MirthBlockConfigSchema>;

export const MirthBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Mirth),
  config: MirthBlockConfigSchema,
});

export type MirthBlock = z.infer<typeof MirthBlockSchema>;
